import { render, staticRenderFns } from "./boreholes.vue?vue&type=template&id=85f75fba&"
import script from "./boreholes.ts?vue&type=script&lang=ts&"
export * from "./boreholes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports